// extracted by mini-css-extract-plugin
export default {"modal":"vK0TmpK","center":"ny8RcG1","isOpen":"OwoXMZ_","side":"GMOdGOB","slideOpen":"opb8xVV","large":"Eks6QGF","fadeIn":"OJ_0Ufp"};